<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="true"
    custom-class="register-dialog" @close="handleClose">
    <div class="dialog-content">
      <!-- 左侧图片区域 -->
      <div class="dialog-left-image">
        <img src="@/assets/51.png" alt="注册图片" />
      </div>
      <!-- 右侧内容区域 -->
      <div class="dialog-right-content">
        <span class="title-text">绑定手机号</span>
        <div class="register-form">
          <div class="form-item">
            <div class="input-wrapper">
              <i class="el-icon-mobile-phone input-icon"></i>
              <el-input v-model="form.phone" placeholder="输入手机号" maxlength="11" @input="onPhoneInput"></el-input>
            </div>
          </div>
          <div class="form-item">
            <div class="input-wrapper code-input-wrapper">
              <el-image :src="require('@/assets/55.png')" class="input-icon-image" />
              <el-input v-model="form.code" placeholder="输入验证码" maxlength="6"></el-input>
              <el-button class="get-code-btn" :disabled="codeCountdown > 0 || !isPhoneValid" @click="handleGetCode">
                {{ codeCountdown > 0 ? `${codeCountdown}秒` : '获取验证码' }}
              </el-button>
            </div>
          </div>
          <div class="form-item">
            <div class="input-wrapper">
              <i class="el-icon-lock input-icon"></i>
              <el-input v-model="form.password" type="password" placeholder="输入密码(6-12位字母+数字)" :show-password="true"
                maxlength="12"></el-input>
            </div>
          </div>
          <el-button type="primary" class="register-btn" :loading="loading" @click="handleRegister">
            确认
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { bindOpenId, sendCode } from '@/api/login'
import { loginIM } from '@/utils/im'
export default {
  name: 'BindPhoneDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    wxOpenId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      codeCountdown: 0,
      form: {
        phone: '',
        code: '',
        password: '',
        agreed: true
      },
    }
  },
  computed: {
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.form.phone)
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    handleClose() {
      this.resetForm()
      this.$emit('close')
    },
    // 忘记密码手机号输入只允许数字
    onPhoneInput() {
      this.form.phone = String(this.form.phone || '').replace(/[^\d]/g, '').slice(0, 11)
    },

    validatePhone() {
      if (!this.form.phone) {
        this.$message.error('请输入手机号')
        return false
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.error('请输入正确的手机号')
        return false
      }
      return true
    },
    validateCode() {
      if (!this.form.code) {
        this.$message.error('请输入验证码')
        return false
      }
      if (!/^\d{6}$/.test(this.form.code)) {
        this.$message.error('验证码为6位数字')
        return false
      }
      return true
    },
    validatePassword() {
      if (!this.form.password) {
        this.$message.error('请输入密码')
        return false
      }
      if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,12}$/.test(this.form.password)) {
        this.$message.error('密码为6-12位字母+数字')
        return false
      }
      return true
    },
    async handleGetCode() {
      if (!this.validatePhone()) {
        return
      }

      try {
        this.loading = true
        // 忘记密码验证码：event=1，使用 mobile 字段
        const res = await sendCode({ event: 'bindThird', mobile: this.form.phone })
        if (res.code === 1) {
          this.$message.success('验证码已发送')
          this.startCountdown()
        } else {
          this.$message.error(res.msg || '发送验证码失败')
        }
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.loading = false
      }
    },
    startCountdown() {
      this.codeCountdown = 60
      const timer = setInterval(() => {
        this.codeCountdown--
        if (this.codeCountdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },
    // 确认重置密码
    async handleRegister() {
      console.log('wxOpenId',this.wxOpenId);
      
      if (!this.validatePhone() || !this.validateCode() || !this.validatePassword()) {
        return
      }

      try {
        this.loading = true
        const res = await bindOpenId({
          mobile: this.form.phone,
          captcha: this.form.code,
          cid: 1,
          client: 3,
          event: 'bindThird',
          password: this.form.password,
          unionID: this.wxOpenId,
          platform: 0
        })

        if (res.code === 1) {
          this.$message.success('绑定成功')
          this.$store.commit('user/SET_TOKEN', res.data.token)
          this.$store.commit('user/SET_USER_INFO', res.data.userVo)
          sessionStorage.removeItem('wxScanOpenId')
          try {
            await loginIM()
          } catch (err) {
            console.warn('[IM] 注册后预登录失败:', err && err.message)
          }
          this.dialogVisible = false
          // 不立即刷新页面，等待完善信息弹窗后再刷新
          this.$emit('register-success', { showCompleteInfo: true })
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      this.form = {
        phone: '',
        code: '',
        password: '',
        agreed: true
      }
      this.codeCountdown = 0
    },

  }
}
</script>

<style scoped lang="scss">
.agreement-link {
  color: #333;
  cursor: pointer;
}

.input-icon-image {
  width: 16px;
  height: 16px;
  margin-left: 13px;
  position: absolute;
}

::v-deep .el-dialog {
  width: 800px;
  height: 500px;
  margin-top: 0 !important;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px !important;
}

::v-deep .el-dialog__header {
  padding: 0 !important;
  border-bottom: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

::v-deep .el-dialog__body {
  padding: 0 !important;
  height: 500px;
  overflow: hidden;
}

.title-text {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 40px;
}

.register-dialog {
  width: 800px;
  height: 500px;
  background: #FFFFFF;
  border-radius: 12px;
}

.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
  z-index: 10;



  .close-icon {
    font-size: 20px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #333;
    }
  }
}

.dialog-content {
  display: flex;
  height: 500px;
  padding: 0;
}

.dialog-left-image {
  width: 360px;
  height: 500px;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.dialog-right-content {
  flex: 1;
  padding: 20px 55px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
}

.register-form {
  .form-item {
    margin-bottom: 20px;

    .input-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #DDDDDD;
      background: #FFFFFF;
      width: 100%;
      height: 50px;

      .input-icon {
        position: absolute;
        left: 12px;
        font-size: 18px;
        color: #999;
        z-index: 1;
      }

      ::v-deep .el-input__inner {
        width: 100%;
        padding-left: 40px;
        border: none;
        background: none;
      }

      &.code-input-wrapper {
        ::v-deep .el-input {
          flex: 1;
          margin-right: 12px;
        }
      }
    }

    .get-code-btn {
      width: 120px;
      height: 50px;
      padding: 0;
      flex-shrink: 0;
      border: none;
      background: none;
      color: #333333;
      font-size: 14px;
    }

    .error-text {
      margin-top: 4px;
      font-size: 12px;
      color: #f56c6c;
    }
  }

  .form-actions {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;

    .link-login {
      font-weight: 700;
      font-size: 14px;
      text-decoration: underline;
    }

    .link-text {
      font-size: 14px;
    }
  }

  .agreement-checkbox {
    margin-bottom: 24px;
    font-size: 12px;
    color: #666;
    display: flex;
    justify-content: center;

    ::v-deep .el-checkbox__label {
      font-size: 12px;
    }


  }

  .register-btn {
    width: 100%;
    height: 50px;
    font-size: 16px;
    background-color: #2A2A28;
    border-color: #2A2A28;
    border-radius: 12px;
    color: #FFF6AF;
    margin-top: 20px;

    &:hover {
      background-color: #3a3a38;
      border-color: #3a3a38;
    }
  }
}
</style>
